module.exports = __webpack_public_path__ + "1ef24acb06cf73a6ec98ca80256a9980.pdf";